// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3cDTr","emails":"CreateEditClinics_emails__24tFK","emailTagLabel":"CreateEditClinics_emailTagLabel__3LVkI"};